import { useTranscriptionStore } from '../store/useTranscriptionStore';
import { useTranslationStore } from '../store/useTranslationStore';

// The two points where the transcript meets the displayed translation. They live
// here rather than in the transcription store so the two stores do not have to
// import each other.
export const useTranscriptContent = () => {
  // The transcript tab loads lazily, so a load that lands while a translation is
  // displayed must show the translated segments.
  const load = async (transcriptionId?: string) => {
    const transcriptionStore = useTranscriptionStore();
    await transcriptionStore.loadTranscription(transcriptionId);

    const translated = useTranslationStore().activeTranscription;
    if (translated) {
      transcriptionStore.$patch({ transcription: { data: translated.map(segment => ({ ...segment })) } });
    }
  };

  const saveEdits = async () => {
    const transcriptionStore = useTranscriptionStore();
    const translationStore = useTranslationStore();

    if (!translationStore.isTranslationActive) {
      return transcriptionStore.lineSaveAll();
    }

    return translationStore.updateContent({ transcription: transcriptionStore.editedSegments });
  };

  return { load, saveEdits };
};
